// src/components/upload/upload.styles.tsx
import { tv } from "tailwind-variants";
var uploadStyles = tv({
  slots: {
    error: "text-primary-700 text-xs"
  },
  variants: {}
});
export {
  uploadStyles
};
